$(() => {
  /**
   * Manage a registrant form
   *
   * https://raceroster.com
   */
  $.RegistrantPlugin = function registrantPlugin(options) {
    const defaults = {
      registrantUuid: null,
      registrantIndex: 1,
      subEventId: null,
      registrationUrl: null,
      entryUrl: null,
      eventUrl: null,
      subEventsUrl: null,
      subEventSelectionUrl: null,
      membershipValidationUrl: null,
      startGroupValidationUrl: null,
      eventCountry: null,
      i18n: {},
      usat: {},
      hasCustomSubEventRequiredFields: false,
      subEventRequiredFields: {},
      eventRequiredFields: {},
      accountPersonalInformation: null,
      suggestedRegistrantsPersonalInformation: null,
      registrantPersonalInformation: null,
      registrantsPersonalInformation: null,
      ageMinimumDefault: null,
      ageMinimums: {},
      subEventAgeLimits: null,
      language: 'en',
      languageRegion: 'US',
      autocompleteService: 'google',
      isWebView: false,
      separateFeatureSteps: false,
      selectOnlySubEvent: true,
      ageModalRedirectRoute: null,
      callbacks: {
        subEventSelected: () => {},
        registrantSaved: () => {},
      },
    };

    const plugin = this;

    let settings = {};
    let i18n = {};
    const html = {
      spinner: '<span class="fa fa-3x fa-spinner fa-pulse" aria-hidden="true"></span>',
    };
    let registrantFeaturesRequest = null;

    const $pluginContainer = $('.js-registrant');
    const $snackBar = $('[data-js-snack-bar]');

    // Components of a registrant
    const components = {
      // no plugin for registrant management
      registrantManagement: {
        form: $pluginContainer.find('.js-switch-registrant-form'),
      },
      accessCodes: {
        form: $pluginContainer.find('.js-access-codes'),
        plugin: null,
      },
      personalInformation: {
        form: $pluginContainer.find('.js-registrant-personal-information-form'),
        plugin: null,
      },
      startGroups: {
        form: $pluginContainer.find('.js-registrant-start-groups-form'),
        plugin: null,
        pluginName: 'startGroupsPlugin',
      },
      registrationQuestions: {
        form: $pluginContainer.find('.js-registrant-questions-form'),
        plugin: null,
        pluginName: 'questionsPlugin',
      },
      memberships: {
        form: $pluginContainer.find('.js-registrant-memberships-form'),
        plugin: null,
      },
      teams: {
        form: $pluginContainer.find('.js-registrant-teams-form'),
        plugin: null,
      },
      products: {
        form: $pluginContainer.find('.js-registrant-products-form'),
        plugin: null,
      },
      usat: {
        form: $pluginContainer.find('.js-registrant-usat-form'),
        plugin: null,
      },
      promoCodes: {
        form: $pluginContainer.find('.js-registrant-promo-codes-form'),
        plugin: null,
      },
      subEvents: {
        form: $pluginContainer.find('.js-registrant-sub-events-form'),
        plugin: null,
        pluginName: 'subEventsPlugin',
      },
      fundraisingSettings: {
        form: $pluginContainer.find('.js-registrant-fundraising-settings-form'),
        plugin: null,
      },
    };

    /**
     * Get the requested plugin
     * @param {string} name
     */
    plugin.getPlugin = (name) => components[name].plugin || null;

    /**
     * Parse the error message from response
     *
     * @param {object} response
     * @returns {string}
     */
    plugin.parseErrorMessage = (response) => {
      if (typeof response.responseJSON !== 'object') {
        return response.responseText;
      }

      // not sure if it's possible for the backend to return something that doesn't have the
      // errors property, but just in case, we'll show a generic "try again"
      if (!response.responseJSON.errors) {
        return settings.i18n.genericError;
      }

      const { errors } = response.responseJSON;
      let errorMessage = '';

      if (Object.keys(errors).length > 0) {
        if (Object.keys(errors).length > 1) {
          $.each(errors, (key, error) => {
            errorMessage += `• ${error}\n`;
          });
        } else {
          [errorMessage] = Object.values(errors);
        }

        return errorMessage;
      }

      return errorMessage;
    };

    /**
     * Don't let em submit again
     */
    plugin.disableSubmitButtons = ($button) => {
      $pluginContainer.find('button[type="submit"]').prop('disabled', true);

      // Display the spinner for the button that was clicked
      if (typeof $button !== 'undefined') {
        $button.find('.js-spinner').removeClass('hidden');
      }
    };

    /**
     * Okay fine let em submit again
     */
    plugin.reEnableSubmitButtons = () => {
      $pluginContainer.find('button[type="submit"]').not('[data-disabled="true"]').prop('disabled', false);
      $pluginContainer.find('.js-spinner').addClass('hidden');
    };

    /**
     * For when the server is a little grumpy
     * @param content
     */
    const addDangerSnack = (content) => {
      if (!content) {
        return;
      }

      $snackBar.snackBar('add', {
        type: 'danger',
        icon: 'exclamation-circle',
        content,
      });
    };

    /**
     * Takes an error message, splits it up and removes the weird bullety stuff, then sends it along to be made
     * into a delicious danger snack.
     * @param error
     */
    const alertErrorMessage = (error) => {
      if (!error) {
        return;
      }

      error
        .split(/\r?\n/)
        .forEach((singleError) => {
          if (!singleError) {
            return;
          }

          addDangerSnack(singleError.replace('•', '').trim());
        });
    };

    /**
     * Serialize a component
     * @param {object} component
     * @returns {string}
     */
    const serializeComponent = (component) => {
      if (component.plugin?.[component.pluginName]?.getMethods?.serialize) {
        return component.plugin[component.pluginName]('serialize');
      }

      if (component.plugin?.serialize) {
        return component.plugin.serialize();
      }

      return component.form.serialize();
    };

    /**
     * Loops through all the components' forms and builds a data string out of their form serializations to be used
     * in ajax requests
     * @returns {string}
     */
    const serializeComponents = () => {
      // not sure if `components` can ever be a falsey value, but just in case, we'll just
      // return an empty string
      if (!components) {
        return '';
      }

      return Object
        .values(components)
        .reduce((data, component) => {
          if (component.form.data('disabled')) {
            return data;
          }

          const serializedForm = serializeComponent(component);

          if (!serializedForm) {
            return data;
          }

          // Extract feature name for metrics key
          const $featureInput = component.form.find('input[name=feature]');
          const featureKey = $featureInput.length ? $featureInput.val() : component.form.attr('name');

          // if the plugin has metrics, attach em in json format
          const metrics = component.plugin?.getMetrics
            /* eslint-disable-next-line max-len */
            ? `${encodeURIComponent(`metrics[${featureKey}]`)}=${encodeURIComponent(JSON.stringify(component.plugin.getMetrics()))}&`
            : '';

          return `${data}${serializedForm}&${metrics}`;
        }, '');
    };

    /**
     * When an input with a pattern attribute is invalid, add an accessible help block
     * @param $field
     */
    const invalidPattern = ($field) => {
      const $container = $field.closest('.form-group');
      const $parent = $container.length ? $container : $field.parent();
      const $helpBlock = $parent.find('.help-block');
      const message = $field.attr('title') || '';

      if (message !== '') {
        if ($helpBlock.length) {
          $helpBlock.text(message);
        } else {
          $parent.append(`<p class="help-block" id="${$field.attr('id')}-error">${message}</p>`);
        }

        $field.attr('aria-describedby', `${$field.attr('id')}-error`);
      }

      // there's some silly float css causing the help block to look awful without the clearfix
      $parent.addClass('has-error clearfix');
    };

    /**
     * Is the form valid?
     * @returns {boolean}
     * @private
     */
    const isFormValid = () => {
      let invalid = false;

      // Validate each of the component forms
      $.each(components, (index, component) => {
        const $form = component.form;

        if ($form.length && !$form[0].checkValidity()) {
          $form.find('input:invalid, select:invalid, textarea:invalid').each(function addErrors() {
            const $this = $(this);

            $this.parent().addClass('has-error');

            if ($this.is('[pattern]')) {
              invalidPattern($this);
            }

            // Focus on the first invalid field
            if ($this.is(':visible') && !invalid) {
              invalid = true;
              $this.focus();

              // Create and click a temporary button to trigger the HTML5 submit validation
              const tmpSubmit = document.createElement('button');
              $form[0].appendChild(tmpSubmit);
              tmpSubmit.click();
              $form[0].removeChild(tmpSubmit);
            }
          });
        }

        // Check the validity of the phone number fields
        $form.find('[data-format-phone-number]').each((key, element) => {
          const $element = $(element);
          const phoneNumber = window.intlTelInput.getInstance(element);

          // Only validate client side if visible and a value has been input by the user
          // (required validation is done by the browser itself)
          if ($element.is(':visible') && $element.val() && !phoneNumber.isValidNumber()) {
            invalid = true;
            invalidPattern($element);
            $element.focus();
          }
        });

        $form.find('[data-has-option-selection-quantity-restrictions]').each((key, element) => {
          const $element = $(element);
          const minimum = parseInt($element.attr('data-minimum-option-selection') || 0, 10);
          const maximum = parseInt($element.attr('data-maximum-option-selection') || 0, 10);
          const $checkboxes = $element.find('[type="checkbox"]');
          const selectionQuantity = $checkboxes.filter(':checked').length;
          let quantityRestrictionSatisfied = true;

          if (minimum && selectionQuantity < minimum) {
            quantityRestrictionSatisfied = false;
          }

          if (maximum && selectionQuantity > maximum) {
            quantityRestrictionSatisfied = false;
          }

          if (!quantityRestrictionSatisfied) {
            invalid = true;
            $element.closest('.form-group').addClass('has-error');
            $checkboxes.first().trigger('focus');
          }
        });
      });

      // Prevent submitting if the form is not valid
      return !invalid;
    };

    /**
     * Save a registrant and redirect the user to the returned destination
     */
    plugin.saveRegistrant = function saveRegistrant(event, checkAge = true) {
      if (event) {
        event.preventDefault();
      }

      // Use browser validation first
      if (!isFormValid()) {
        return;
      }

      if (checkAge && !components.personalInformation.plugin.checkAge()) {
        $pluginContainer.find('.js-age-modal').data('actionButton', this).modal('show');
        return;
      }

      // We know which button was clicked in this case, so we're going to add a spinner to it
      plugin.disableSubmitButtons($(this));

      // serialize the data then tack on the button value
      const data = `${serializeComponents()}&action=${$(this).val()}`;

      $.ajax({
        url: $('#registration-form').attr('action'),
        type: 'post',
        data,
        dataType: 'json',
      })
        .done((response) => {
          settings.callbacks.registrantSaved();
          window.location.href = response.redirect;
        })
        .fail((response) => {
          alertErrorMessage(plugin.parseErrorMessage(response));
          plugin.reEnableSubmitButtons();
        });
    };

    /**
     * Submits the current registration's information and if it was good, switch to the request registrant
     * @param event
     */
    const switchRegistrant = function switchRegistrant(event) {
      const newRegistrantIndex = parseInt($(this).find('.js-switch-registrant-select').val(), 10);

      event.preventDefault();

      if (newRegistrantIndex === settings.registrantIndex || !isFormValid()) {
        return;
      }

      plugin.disableSubmitButtons();

      $.ajax({
        url: settings.switchRegistrantUrl,
        type: 'post',
        data: serializeComponents(),
        success: ({ redirect }) => {
          window.location.href = redirect;
        },
        error: (response) => alertErrorMessage(plugin.parseErrorMessage(response)),
        complete: plugin.reEnableSubmitButtons,
      });
    };

    /**
     * Cancel any active requests being made
     */
    const cancelActiveRequests = () => {
      if (registrantFeaturesRequest) {
        registrantFeaturesRequest.abort();
      }

      $.each(components, (index, component) => {
        if (!component.plugin) {
          return;
        }

        if (component.plugin instanceof jQuery) {
          component.plugin[component.pluginName]?.('cancelActiveRequests');
          return;
        }

        component.plugin.cancelActiveRequests?.();
      });
    };

    /**
     * Removes the current registrant from the registration
     */
    const removeRegistrant = () => {
      plugin.disableSubmitButtons();
      cancelActiveRequests();

      $.ajax({
        url: settings.removeRegistrantUrl,
        type: 'post',
        data: serializeComponents(),
        success: ({ redirect }) => {
          window.location.href = redirect;
        },
        error: (response) => alertErrorMessage(plugin.parseErrorMessage(response)),
        complete: plugin.reEnableSubmitButtons,
      });
    };

    /**
     * Toggle the visibility of the registrant spinner
     *
     * @param isVisible
     * @private
     */
    plugin.toggleRegistrantSpinner = (isVisible) => {
      const $registrantSpinner = $pluginContainer.find('.js-registrant-spinner');

      if (isVisible) {
        $registrantSpinner.html(html.spinner).fadeIn(200);
      } else {
        $registrantSpinner.fadeOut();
      }
    };

    /**
     * Toggle the visibility of registrant components
     *
     * @param isVisible
     * @private
     */
    const toggleComponents = (isVisible) => {
      $.each(components, (index, component) => {
        if (component.form.hasClass('js-registrant-feature-form')) {
          component.plugin.toggleVisibility?.(isVisible);
        }
      });
    };

    /**
     * Clear the content of the previous sub-event features
     *
     * @private
     */
    const clearRegistrationComponents = () => {
      $.each(components, (index, component) => {
        if (component.plugin?.[component.pluginName]?.methods?.clear) {
          component.plugin[component.pluginName]('clear');
        } else if (component.form.hasClass('js-registrant-feature-form')) {
          component.plugin.clear?.();
        }
      });
    };

    /**
     * Display error message and redirect user if 406 error response
     *
     * @param response
     * @private
     */
    plugin.handleErrorResponse = (response) => {
      // Display an error message alert if a message is returned
      if (response.responseText) {
        alertErrorMessage(response.responseText);
      }

      // The registration is invalid, redirect the user out of registration
      if (response.status === 406) {
        window.location.replace(settings.eventUrl);
      }
    };

    /**
     * Shows the submit buttons if they should be shown
     * @param $subEvent
     * @private
     */
    const showSubmitButtons = ($subEvent) => {
      const hasAddRegistrantButton = $subEvent.is('select')
        ? $subEvent.find(':selected').data('allow-add')
        : $subEvent.data('allow-add');

      $pluginContainer
        .find('.js-add-registrant')
        .data('disabled', !hasAddRegistrantButton)
        .prop('disabled', !hasAddRegistrantButton)
        .toggleClass('hidden', !hasAddRegistrantButton);

      $pluginContainer
        .find('.js-continue,.js-add-team-member')
        .not('[data-disabled="true"]')
        .prop('disabled', false)
        .removeClass('hidden');
      $pluginContainer
        .find('.js-registrant-terms-form')
        .removeClass('hidden');
    };

    /**
     * Hides the submit buttons
     * @private
     */
    const hideSubmitButtons = () => {
      $pluginContainer.find('.js-add-registrant').addClass('hidden');
      $pluginContainer.find('.js-continue,.js-add-team-member').addClass('hidden');
      $pluginContainer.find('.js-registrant-terms-form').addClass('hidden');
    };

    /**
     * Initialize the plugin content. Logic included to make sure that if the plugin is jQuery,
     * the jQuery method is called. Otherwise, call the older class-style method.
     * @param featureIdentifier
     */
    plugin.initializeFeatureContent = (featureIdentifier) => {
      if (!settings.subEventId) {
        return;
      }

      const component = components[featureIdentifier];

      if (!component) {
        return;
      }

      if (component.plugin instanceof jQuery) {
        component.plugin[component.pluginName]?.('initializeContent');
        return;
      }

      components[featureIdentifier].plugin.initializeContent(settings.subEventId);
    };

    /**
     * Get the features for the registrant
     *
     * @private
     */
    plugin.loadRegistrantFeatures = ($subEvent, subEventId) => {
      // If we're rendering the features as separate steps, we will instead simply submit
      if (settings.separateFeatureSteps) {
        plugin.toggleRegistrantSpinner(true);
        plugin.saveRegistrant.call($pluginContainer.find('.js-continue'), null, false);
        return;
      }

      if (registrantFeaturesRequest) {
        registrantFeaturesRequest.abort();
      }

      // Display the personal information component while other components are loading
      components.personalInformation.plugin.toggleVisibility(true);

      registrantFeaturesRequest = $.ajax({
        url: `${settings.registrationUrl}/registrant/${settings.registrantIndex}/features`,
        type: 'GET',
      }).always(() => {
        registrantFeaturesRequest = null;
      }).done(({ data }) => {
        if (typeof data.registrant !== 'undefined') {
          components.personalInformation.plugin.displayContent(data.registrant, subEventId);
        }

        if (typeof data['start-groups'] !== 'undefined') {
          components.startGroups.form.startGroupsPlugin('setup', data['start-groups']);
        }

        if (typeof data.teams !== 'undefined') {
          components.teams.plugin.displayContent(data.teams);
        }

        if (typeof data.products !== 'undefined') {
          components.products.plugin.displayContent(data.products);
        }

        if (typeof data.questions !== 'undefined') {
          components.registrationQuestions.plugin.displayContent(data.questions);
        }

        if (typeof data.memberships !== 'undefined') {
          components.memberships.plugin.displayContent(data.memberships);
        }

        if (typeof data.usat !== 'undefined') {
          components.usat.plugin.displayContent(data.usat);
        }

        if (typeof data['promo-codes'] !== 'undefined') {
          components.promoCodes.plugin.displayContent(data['promo-codes']);
        }

        if (typeof data['fundraising-settings'] !== 'undefined') {
          components.fundraisingSettings.plugin.displayContent(data['fundraising-settings']);
        }

        plugin.toggleRegistrantSpinner(false);

        // Display the components
        toggleComponents(true);

        showSubmitButtons($subEvent);
      }).fail((response) => {
        plugin.toggleRegistrantSpinner(false);
        plugin.handleErrorResponse(response);
      });
    };

    /**
     * Disable and toggle visibility of components
     */
    plugin.unloadRegistrationComponents = (showSpinner = true) => {
      components.personalInformation.plugin.toggleVisibility(false);
      plugin.toggleRegistrantSpinner(showSpinner);
      toggleComponents(false);
      clearRegistrationComponents();
      hideSubmitButtons();
    };

    /**
     * Don't let hitting enter submit any forms
     * @param event
     */
    const preventEnterSubmission = (event) => {
      const code = event.keyCode || event.which;

      if (code === 13 && event.target.nodeName !== 'TEXTAREA') {
        event.preventDefault();
      }
    };

    /**
     * Remove error formatting if valid
     */
    const removeErrorFormatting = function removeErrorFormatting() {
      const $this = $(this);

      if ($this.is(':valid')) {
        $this.parent().removeClass('has-error');
      }
    };

    /**
     * We originally thought the user didn't meet the age requirements, but then they indicated they are registering
     * someone else. Switch the myself/someone else radio to someone else then submit the form using the button
     * they clicked before the modal open
     * @param event
     */
    const saveSomeoneElse = (event) => {
      const $ageModal = $pluginContainer.find('.js-age-modal');

      $pluginContainer.find('.js-register-someone-else').prop('checked', true);
      $ageModal.modal('hide');

      plugin.saveRegistrant.call($ageModal.data('actionButton'), event, false);
    };

    /**
     * User doesn't meet age requirements so send em to the error page
     */
    const redirectToProcessingError = () => {
      window.location.href = settings.ageModalRedirectRoute;
    };

    /**
     * Initialize the listeners for the registrant form
     *
     * @private
     */
    const initializeListeners = () => {
      $pluginContainer.on('submit', '.js-switch-registrant-form', switchRegistrant);
      $pluginContainer.on('click', '.js-remove-registrant', removeRegistrant);
      $pluginContainer.on('keyup keypress', preventEnterSubmission);
      $pluginContainer.on('blur', ':input', removeErrorFormatting);
      $pluginContainer.on('click', '.js-registration-form :submit', plugin.saveRegistrant);
      $pluginContainer.on('click', '.js-age-modal-someone-else', saveSomeoneElse);
      $pluginContainer.on('click', '.js-age-modal-myself', redirectToProcessingError);
    };

    /**
     * Initialize plugin
     * Merge default settings with those passed in
     */
    const initialize = () => {
      settings = $.extend({}, defaults, options);

      ({ i18n } = settings);

      // create instance of registration questions plugin
      components.registrationQuestions.plugin = components.registrationQuestions.form
        .registrationQuestionsPlugin({
          registrationPlugin: plugin,
          i18n: settings.i18n,
          eventCountry: settings.eventCountry,
          registrantIndex: settings.registrantIndex,
          registrantPersonalInformation: settings.registrantPersonalInformation,
          callbacks: {
            getProvidedFor: () => components.personalInformation.plugin?.getProvidedFor(),
            getSelectedCountry: () => components.personalInformation.plugin?.getSelectedCountry(),
          },
        });

      // create instance of personal information plugin
      components.personalInformation.plugin = components.personalInformation.form.personalInformationPlugin({
        registrationPlugin: plugin,
        eventCountry: settings.eventCountry,
        registrationUrl: settings.registrationUrl,
        registrantIndex: settings.registrantIndex,
        eventRequiredFields: settings.eventRequiredFields,
        subEventRequiredFields: settings.subEventRequiredFields,
        hasCustomSubEventRequiredFields: settings.hasCustomSubEventRequiredFields,
        i18n: settings.i18n,
        accountPersonalInformation: settings.accountPersonalInformation,
        suggestedRegistrantsPersonalInformation: settings.suggestedRegistrantsPersonalInformation,
        registrantPersonalInformation: settings.registrantPersonalInformation,
        registrantsPersonalInformation: settings.registrantsPersonalInformation,
        ageMinimumDefault: settings.ageMinimumDefault,
        ageMinimums: settings.ageMinimums,
        subEventAgeLimits: settings.subEventAgeLimits,
        language: settings.language,
        languageRegion: settings.languageRegion,
        autocompleteService: settings.autocompleteService,
        registrationQuestionsPlugin: components.registrationQuestions.plugin,
        callbacks: {
          onGivenNameChange: () => {
            components.startGroups.form.startGroupsPlugin('update');
          },
          onFamilyNameChange: () => {
            components.startGroups.form.startGroupsPlugin('update');
          },
          onDateOfBirthChange: () => {
            components.startGroups.form.startGroupsPlugin('update');
          },
        },
      });

      // create instance of start groups plugin
      components.startGroups.plugin = components.startGroups.form.startGroupsPlugin({
        registrationPlugin: plugin,
        registrationUrl: settings.registrationUrl,
        i18n: settings.i18n,
        registrantPersonalInformation: settings.registrantPersonalInformation,
        registrantIndex: settings.registrantIndex,
        registrantUuid: settings.registrantUuid,
        routes: {
          validation: settings.startGroupValidationUrl,
        },
        callbacks: {
          getGivenName: () => components.personalInformation.plugin.getGivenName(),
          getFamilyName: () => components.personalInformation.plugin.getFamilyName(),
          getDateOfBirth: () => components.personalInformation.plugin.getDateOfBirth(),
        },
      });

      // create instance of teams plugin
      components.teams.plugin = components.teams.form.teamsPlugin({
        registrationPlugin: plugin,
        registrationUrl: settings.registrationUrl,
        registrantIndex: settings.registrantIndex,
        registrantsPersonalInformation: settings.registrantsPersonalInformation,
        i18n: {
          ...i18n.teamPhrases,
          loading: i18n.loading,
          noResultsFound: i18n.noResultsFound,
        },
        eventCountry: settings.eventCountry,
      });

      // create instance of products plugin
      components.products.plugin = components.products.form.productsPlugin({
        registrationPlugin: plugin,
        registrationUrl: settings.registrationUrl,
        i18n: settings.i18n,
      });

      // create instance of memberships plugin
      components.memberships.plugin = components.memberships.form.membershipsPlugin({
        registrationPlugin: plugin,
        personalInformation: components.personalInformation,
        registrationUrl: settings.registrationUrl,
        registrantIndex: settings.registrantIndex,
        membershipValidationUrl: settings.membershipValidationUrl,
        i18n: settings.i18n,
      });

      // create instance of USAT plugin
      components.usat.plugin = components.usat.form.usatPlugin({
        registrationPlugin: plugin,
        personalInformation: components.personalInformation,
        registrantPersonalInformation: settings.registrantPersonalInformation,
        registrationUrl: settings.registrationUrl,
        i18n: settings.i18n,
        usat: settings.usat,
      });

      // create instance of promo codes plugin
      components.promoCodes.plugin = components.promoCodes.form.promoCodesPlugin({
        registrationPlugin: plugin,
        registrationUrl: settings.registrationUrl,
        i18n: settings.i18n,
      });

      // create instance of fundraising settings plugin
      components.fundraisingSettings.plugin = components.fundraisingSettings.form.fundraisingSettingsPlugin({
        registrationPlugin: plugin,
        registrationUrl: settings.registrationUrl,
        i18n: settings.i18n,
      });

      // create instance of sub-events plugin
      components.subEvents.plugin = components.subEvents.form.subEventsPlugin({
        selectOnlySubEvent: settings.selectOnlySubEvent,
        routes: {
          subEvents: settings.subEventsUrl,
          subEventSelection: settings.subEventSelectionUrl,
        },
        callbacks: {
          subEventSelected: ($element, data, $subEvent, subEventId, subEventName, subEventPrice) => {
            settings.callbacks.subEventSelected({
              subEventId,
              subEventName,
              subEventPrice,
            });
          },
          toggleRegistrantSpinner: ($element, data, showSpinner) => {
            plugin.toggleRegistrantSpinner(showSpinner);
          },
          loadRegistrantFeatures: ($element, data, $subEvent, subEventId) => {
            plugin.loadRegistrantFeatures($subEvent, subEventId);
          },
          handleErrorResponse: ($element, data, error) => {
            plugin.handleErrorResponse(error);
          },
          unloadRegistrationComponents: ($element, data, showSpinner) => {
            plugin.unloadRegistrationComponents(showSpinner);
          },
        },
      });

      // create instance of access codes plugin
      components.accessCodes.plugin = components.accessCodes.form.accessCodesPlugin({
        i18n: settings.i18n,
        accessCodeUrl: settings.accessCodeUrl,
        callbacks: {
          accessCodeValidated: () => {
            components.subEvents.plugin.subEventsPlugin('reloadRegistrantSubEventSelector', true);
          },
        },
      });

      // initialize popovers loaded by ajax
      $('body').popover({
        placement: 'top',
        container: 'body',
        html: true,
        selector: '[data-toggle="popover"]',
      });

      initializeListeners();
    };

    // Fire up
    initialize();
  };
});
